<template>
  <div class="login-page">
    <div class="container-fluid login-container">
      <div class="row">
        <div class="col login-form-container">
          <div class="login-form">
            <div class="login-form-header">
              <div class="logo-box">
                <img src="../assets/logo.png" alt="" srcset="">
              </div>
              <div class="text-box">
                <h2>Get Started</h2>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
                <span></span>
              </div>
            </div>
            <LoginForm @login="handleLogin" :loading="loading" />
          </div>
        </div>
        <div class="col image-container d-none d-lg-block ">
          <div class="img-box">
            <div class="over-lay"></div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>


<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import LoginForm from '@/components/auth/LoginForm.vue';

export default {
  components: { LoginForm },
  setup() {
    const loading = ref(false); // Reactive state
    const router = useRouter(); // Router instance
    const store = useStore(); // Vuex store instance

    // Login handler
    const handleLogin = async (credentials) => {
      loading.value = true; // Start loading
      try {
        await store.dispatch('auth/login', credentials); // Dispatch login action
        store.dispatch('error/triggerError', {message:'Login Successfully' , type:'success'});
        router.push('/'); // Redirect on success
      } catch (error) {

        store.dispatch('error/triggerError', {message:error , type:'faild'});
      } finally {
        loading.value = false; // Stop loading
      }
    };

    return {
      loading,
      handleLogin,
    };
  },
};
</script>




<style lang="scss">
.over-lay{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: .1);
}
.image-container{ 
  padding: 25px 25px !important;
  .img-box{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background-image: url('../assets/957341.jpg') ;
    background-size: cover;
    border-radius: 18px;
    //box-shadow: 0px 0px 20px 0px #00354f52;
  }
}
.login-container{
  min-height: 100vh;
  max-width: 100vw;
  background-color: #ebfaff;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#007db7+0,7db9e8+100 */
  //background: linear-gradient(to bottom,  #007db7 0%,#7db9e8 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

}
.login-form{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50% , -50%);
}


.login-form-container{
  min-height: 100vh;
  position: relative;
  @media (min-width: 772px){
    padding: 25px;
  }
  .login-form-header{
    .text-box{
      position: relative;
      margin-bottom: 50px;
      span::after{
        content: '';
        position: absolute;
        left: 0;
        bottom: -15px;
        width: 140px;
        height: 1px;
        background-color: #04141b;
        border-radius: 5px;
      }
    }
  }
  
  .logo-box{
    //color: white;
    font-weight: 500;
    margin-bottom: 20px;

    display: flex;
    align-items: center;
    gap: 10px;
    img{
      width: 65px;
    }
    @media (max-width:992px){
    }
  }
  input{
    border: solid 1px #DDD;
    padding: 10px 15px;
    font-size: 16px;
    margin: 15px 0px;
    width: 300px;
    border-radius: 8px;
    transition: 0.2s ease-in-out;
    &:focus{
      outline: none;
      border-color: #145c7e;
      transition: 0.2s ease-in-out;
    }
  }
  label{
    display: block;
  }
  button{
    border: 0px;
    padding: 10px;
    width: 300px;
    background-color: #145c7e;
    color: white;
    margin-top: 25px;
    border-radius: 8px;
    transition: 0.2s ease-in-out;
    &:hover{
      background-color: #054755;
      transition: 0.2s ease-in-out;
    }
  }
}

</style>